import { ProductHome, Products } from "./components";

export const ProductComponent = () => {
    return <>
            <ProductHome/>
            <Products/>
        </>
};